import * as React from "react";
import { FC, useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import "./login-page.less";
import {
  getShoppingCartLocal,
  removeShoppingCartLocal,
  setRefreshToken,
  setToken,
} from "shared/plugins/http-service";
import { RootState } from "app.store";
import { Link, Redirect } from "react-router-dom";
import { DefaultErrorMessage } from "shared/constants/message";
import firebase from "firebase/app";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/npm__vi";
import "firebaseui/dist/firebaseui.css";
import "./login-page.less";
import { setLoginUser } from "states/account/account.action";
import {
  createCustomerInfo,
  getProfile,
  login,
  signIn,
  signUp,
  verifyPhone,
} from "states/account/account.api";
import {
  Formik,
  FormikProps,
  Form,
  Field,
  ErrorMessage,
  FormikErrors,
} from "formik";
import { CreatedAccountModel } from "states/account/account.models";
import {
  globalValueSetLoading,
  globalValueSetToast,
} from "states/global-value/global-value.action";
import { ToastModel, ToastType } from "states/global-value/global-value.models";
import { addItemsApi, mergedCartApi } from "states/order/order.api";
import { AddItemsModel } from "states/order/order.models";

type LoginPageProps = FormikProps<CreatedAccountModel> &
  FormikErrors<CreatedAccountModel>;

const initialValues: CreatedAccountModel = {
  name: "",
  email: "",
  idToken: "",
};
const LoginPage: FC<LoginPageProps> = (props) => {
  const isLogin = useSelector(
    (state: RootState) => state.account.isAuthentication,
    shallowEqual
  );
  const { isSubmitting } = props;
  const [tokenTemp, setTokenTemp] = useState<string>("");
  const [isUpdateData, setUpdateData] = useState<boolean>(false);
  const dispatch = useDispatch();

  const getCallbackUrl = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    return params.get("callback");
  };
  const onLoginSubmit = async (idToken: string) => {
    dispatch(globalValueSetLoading(true));
    try {
      const loginResponse = await signIn(idToken);
      setRefreshToken(loginResponse.refreshToken);
      setToken(loginResponse.accessToken);
      await _handleMergedShoppingCart();
      const callbackUrl = getCallbackUrl();
      if (callbackUrl !== null && callbackUrl !== "") {
        window.location.href = callbackUrl;
      } 
      else {
        dispatch(setLoginUser(await getProfile()));
        dispatch(globalValueSetLoading(false));
      }
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleMergedShoppingCart = async () => {
    try {
      let shoppingCart = getShoppingCartLocal();
      if (shoppingCart !== null && shoppingCart !== "") {
        await mergedCartApi(JSON.parse(shoppingCart));
        removeShoppingCartLocal();
      }
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const onCreatedSubmit = async (values: CreatedAccountModel) => {
    dispatch(globalValueSetLoading(true));
    try {
      const loginResponse = await signUp(values);
      setRefreshToken(loginResponse.refreshToken);
      setToken(loginResponse.accessToken);
      await _handleMergedShoppingCart();
      await createCustomerInfo();
      const callbackUrl = getCallbackUrl();
      if (callbackUrl) {
        window.location.href = callbackUrl;
      } else {
        dispatch(setLoginUser(await getProfile()));
        dispatch(globalValueSetLoading(false));
      }
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const uiConfig = {
    signInOptions: [
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        requireDisplayName: false,
        recaptchaParameters: {
          type: "image", // 'audio'
          size: "normal", // 'invisible' or 'compact'
          badge: "bottomleft", //' bottomright' or 'inline' applies to invisible.
        },
        defaultCountry: "VN",
        whitelistedCountries: ["VN", "+84"],
      },
    ],
    callbacks: {
      signInSuccessWithAuthResult: (authResult: any, redirectUrl: any) => {
        firebase
          .auth()
          .currentUser?.getIdToken(true)
          .then(async (idToken) => {
            let response = await verifyPhone(idToken);
            if (response) {
              await onLoginSubmit(idToken);
            } else {
              setUpdateData(true);
              setTokenTemp(idToken);
            }
          });
        return true;
      },
    },
    signInFlow: "popup",
  };
  const initFirebaseUI = () => {
    let firebaseAuth = firebase.auth();
    firebaseAuth.languageCode = "vi";
    if (firebaseui.auth.AuthUI.getInstance()) {
      firebaseui.auth.AuthUI.getInstance()?.start(
        "#firebaseui-auth-container",
        uiConfig
      );
    } else {
      let ui = new firebaseui.auth.AuthUI(firebase.auth());
      ui.start("#firebaseui-auth-container", uiConfig);
    }
    // let ui = new firebaseui.auth.AuthUI(firebaseAuth);
    // ui.reset();
    // ui.start("#firebaseui-auth-container", uiConfig);
  };
  useEffect(() => {
    initFirebaseUI();
    document.title = "Đăng nhập";
  }, []);
  return isLogin ? (
    <Redirect to="/"></Redirect>
  ) : (
    <div className="loginlayout">
      {!isUpdateData ? (
        <React.Fragment>
          <div id="firebaseui-auth-container" className="p-top-4 p-bot-4" />
          <div id="loader" />
        </React.Fragment>
      ) : (
        <div id="update-account" className="container p-4">
          <div className="update-account-inner bg-white p-4 ">
            <Formik
              initialValues={initialValues}
              validate={(values) => {
                let errors: FormikErrors<CreatedAccountModel> = {};
                if (!values.name) {
                  errors.name = "* Họ và tên bắt buộc";
                }
                if (
                  values.email &&
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                  errors.email = "* email không hợp lệ";
                }
                return errors;
              }}
              onSubmit={async (values, actions) => {
                actions.setSubmitting(false);
                values.idToken = tokenTemp;
                await onCreatedSubmit(values);
                actions.setSubmitting(false);
              }}
            >
              <Form>
                <label htmlFor="" className="pb-1">
                  Họ và tên (*):
                </label>
                <Field
                  placeholder="Họ và tên (*)"
                  className="form-control mb-1"
                  type="text"
                  name="name"
                />
                <ErrorMessage
                  name="name"
                  className="mb-1 error-form"
                  component="div"
                />
                <label htmlFor="" className="pb-1">
                  Địa chỉ email:
                </label>
                <Field
                  placeholder="Địa chỉ email"
                  className="form-control mb-1"
                  type="email"
                  name="email"
                />
                <ErrorMessage
                  name="email"
                  className="mb-1 error-form"
                  component="div"
                />
                <div className="btn-container text-center">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    Hoàn thành đăng kí
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
